import React, {useState} from "react";
import "./Departments.css";
import {Link} from "react-router-dom";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation, Pagination, Autoplay} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Faculty
import Faculty from "../Faculty/Faculty"

import VasaviCollegeImg1 from "../../assets/images/Banners/slider-1.jpg";
import VasaviCollegeImg2 from "../../assets/images/Banners/slider-2.jpg";

const Departments = () => {
    SwiperCore.use([Navigation, Pagination, Autoplay]);

    const innerPagesSlide = [
        {id: 1, img: VasaviCollegeImg1, alt: "Slide 1"},
        {id: 2, img: VasaviCollegeImg2, alt: "Slide 2"},
    ];

    // 🔹 State for active tab
    const [activeTab, setActiveTab] = useState("about");

    // 🔹 Tab content data
    const tabContent = {
        about: (
            <>
                <h3>About the Department</h3>
                <p>
                    The Civil Engineering Department was established in the year 1981 and
                    has been in existence right from the inception of the college. It
                    offers B.E. Civil engineering course with an annual intake of 60
                    students.
                </p>
                <p>
                    Department has been conferred with Autonomous Status by the University
                    Grants Commission (UGC) and Osmania University, Hyderabad for a period
                    of six years with effect from the Academic Year 2014-15. The
                    department has been accredited by NBA three times and has
                    accreditation till June 2021. Choice Based Credit System (CBCS) is
                    introduced to the students in academic year 2016-17 . AICTE Model
                    Curriculum was introduced in the year 2018-19. Student enrollment is
                    100% and success rate is 100% for past two years.
                </p>
                <p>
                    Besides high-quality teaching, the Department is actively involved in
                    material testing and consultancy works. The department has 16 highly
                    qualified and experienced faculty members consisting of Professors,
                    Associate Professors and Assistant Professors with an average
                    experience of 15 years and 13 technical and supporting staff with an
                    average experience of 20 years.
                </p>
                <p>
                    Faculty members of the department adopt innovative teaching practices
                    and methods of modern pedagogy for effective teaching learning
                    process. Faculty members are specialized in offering consultancy in
                    the areas of concrete material testing, structural analysis,
                    transportation engineering, water resources engineering and
                    geo-technical Engineering. Total revenue generated from consultancy is
                    Rs 30.00 lakhs in the last five years.
                </p>
                <p>
                    The Department has 10 full-fledged laboratories including a Centre for
                    Geomatics and a project laboratory. The Department also has in its
                    gamut an exclusive computing facility with the latest software in
                    Design, Planning and Management, Remote Sensing, GIS, Land and Water
                    Management, etc.
                </p>
                <p>
                    The undergraduate curriculum comprises of the following: Humanities,
                    Basic and Engineering Sciences, Mathematical, Professional Core and
                    Electives Courses, Open Elective and Skills Development Courses. Apart
                    from the curriculum, students have Co-curricular and Extra-curricular
                    club activities for imparting interpersonal, teamwork / multitasking
                    skills to the students. A total 143 Co-curricular and 15
                    extra-curricular activities were conducted during the past five years.
                </p>
                <p>
                    Open elective courses were introduced to widen their horizons of
                    knowledge and to enable students to work on multidisciplinary
                    projects. NPTEL/MOOCs course helps students to improve their
                    self-learning and knowledge and made mandatory for the award of
                    degree.
                </p>
                <p>
                    A good relationship with industry is maintained for the student
                    training, student internships & projects, industrial visits, expert
                    lectures. Every year third semester students will undergo practical
                    training in professional practice school with the various industries.
                    In addition, regular Industrial visits are organized. Students take up
                    internship with the industry from second year. Final year students
                    take up projects in the industry.
                </p>
                <p>
                    The department encourages students to actively participate in
                    extension and outreach activities under NSS unit which includes Swatch
                    Bharat Campaign, Voter registration, Street Cause, Blood Donation
                    Camps, Tree plantation etc.
                </p>
                <p>
                    The institute follows a Proctorial system in which around twenty
                    students are assigned to each faculty. Besides this, personal
                    counselling is given to students through a qualified professional
                    Student Counsellor. The consistent academic and other support
                    rendered, has resulted in increased net selections in placements and
                    gradual improvement in average pay package. Performance in competitive
                    exams have also increased resulting in admissions into Higher
                    Educational Institutions both in India and Abroad.
                </p>
                <p>
                    The department has organised two international conferences and several
                    national conferences. The department has a vibrant Research
                    environment with linkages to Government R&D Institutes, Industry and
                    Consultancy agencies. The Department was awarded 2 Research Projects
                    worth Rs.5.16 lakhs lakhs by Government Agencies during the past five
                    years. MODROBS sanctioned project worth Rs 14 lakhs has been
                    completed. The Department has 3 functional Memoranda of
                    Understanding’s (MoU’s).
                </p>
            </>
        ),
        vision: (
            <>
                <h3>Department Vision and Mission</h3>

                <h5>Department Vision</h5>
                <p>To strive for excellence in order to make the students better citizens with technical knowledge and
                    social awareness</p>

                <h5>Department Mission</h5>
                <p>To impart knowledge in the latest technologies to the students of civil engineering to fulfil the
                    growing needs of the society.</p>


            </>
        ),
        peos: (
            <>
                <h3>PEOs, POs and PSOs</h3>

                <div className="accordion" id="accordionExample">

                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true"
                                    aria-controls="collapseOne">
                                <span className="">Program Educational Objectives (PEOs)</span>
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show"
                             aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">

                                <ul className="event-highlights">

                                    <li>To provide a better understanding of basic sciences and fundamentals
                                        of civil engineering.
                                    </li>
                                    <li>To develop competence in latest technologies to serve the industry
                                        or pursue higher studies.
                                    </li>
                                    <li>To inculcate professionalism with effective communication skills and
                                        ethical values.
                                    </li>
                                </ul>


                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false"
                                    aria-controls="collapseTwo">
                                PROGRAM OUTCOMES (PO'S)
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <p><em>Engineering Graduates will be able to:</em></p>
                                <ul>
                                    <li><strong>Engineering knowledge:</strong> Apply the knowledge of
                                        mathematics, science, engineering fundamentals, and an engineering
                                        specialization to the solution of complex engineering problems.
                                    </li>
                                    <li><strong>Problem analysis:</strong>Identify, formulate, review research
                                        literature, and analyze complex engineering problems reaching
                                        substantiated conclusions using first principles of mathematics, natural
                                        sciences, and engineering sciences.
                                    </li>
                                    <li><strong>Design/development of solutions:</strong>Design solutions for
                                        complex engineering problems and design system components or processes
                                        that meet the specified needs with appropriate consideration for the
                                        public health and safety, and the cultural, societal, and environmental
                                        considerations.
                                    </li>
                                    <li><strong>Conduct investigations of complex problems:</strong> Use
                                        research-based knowledge and research methods including design of
                                        experiments, analysis and interpretation of data, and synthesis of the
                                        information to provide valid conclusions.
                                    </li>
                                    <li><strong>Modern tool usage:</strong> Create, select, and apply
                                        appropriate techniques, resources, and modern engineering and IT tools
                                        including prediction and modeling to complex engineering activities with
                                        an understanding of the limitations.
                                    </li>
                                    <li><strong>The engineer and society:</strong>Apply reasoning informed by
                                        the contextual knowledge to assess societal, health, safety, legal and
                                        cultural issues and the consequent responsibilities relevant to the
                                        professional engineering practice.
                                    </li>
                                    <li><strong>Environment and sustainability:</strong>Understand the impact of
                                        the professional engineering solutions in societal and environmental
                                        contexts, and demonstrate the knowledge of, and need for sustainable
                                        development.
                                    </li>
                                    <li><strong>Ethics:</strong>Apply ethical principles and commit to
                                        professional ethics and responsibilities and norms of the engineering
                                        practice.
                                    </li>
                                    <li><strong>Individual and team work:</strong>Function effectively as an
                                        individual, and as a member or leader in diverse teams, and in
                                        multidisciplinary settings.
                                    </li>
                                    <li><strong>Communication:</strong>Communicate effectively on complex
                                        engineering activities with the engineering community and with society
                                        at large, such as, being able to comprehend and write effective reports
                                        and design documentation, make effective presentations, and give and
                                        receive clear instructions.
                                    </li>
                                    <li><strong>Project management and finance: </strong>Demonstrate knowledge
                                        and understanding of the engineering and management principles and apply
                                        these to one’s own work, as a member and leader in a team, to manage
                                        projects and in multidisciplinary environments.
                                    </li>
                                    <li><strong>Life-long learning:</strong>Recognize the need for, and have the
                                        preparation and ability to engage in independent and life-long learning
                                        in the broadest context of technological change.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false"
                                    aria-controls="collapseThree">
                                PROGRAM SPECIFIC OUTCOMES (PSOs)
                            </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse"
                             aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <ul>
                                    <li>Understand various concepts of basic engineering sciences and
                                        mathematics to learn advanced concepts of Civil Engineering and apply
                                        them to practical problems.
                                    </li>
                                    <li>Apply principles of various specializations of Civil engineering
                                        including structural engineering, transportation engineering,
                                        environmental engineering, water resources engineering and Geotechnical
                                        engineering to tackle engineering problems.
                                    </li>
                                    <li>Acquire knowledge of ethical practices, communication skills, technical
                                        report writing skills and collaborative effort leading to lifelong
                                        learning.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>

            </>
        ),
        faculty: (
            <>

            <Faculty />
                {/* <h3>Faculty & Staff</h3>
                <p>
                    The department has 16 highly qualified and experienced faculty
                    members...
                </p> */}
            </>
        ),
    };

    return (
        <div className="inner-page-section">
            <div className="container">
                <div className="row">
                    {/* Title */}
                    <div className="col-lg-12">
                        <div className="title-box">
                            <h2>
                                Departments <span className="departments-title">Civil</span>
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="row mt-3">
                    {/* LEFT CONTENT */}
                    <div className="col-lg-8 col-md-8 col-sm-12">
                        {/* Swiper */}
                        {activeTab === "about" && (
                            <div className="slider-box-inner">
                                <Swiper
                                    navigation
                                    pagination={{clickable: true}}
                                    autoplay={{delay: 3000, disableOnInteraction: false}}
                                    loop={true}
                                    slidesPerView={1}
                                >
                                    {innerPagesSlide.map((banner) => (
                                        <SwiperSlide key={banner.id}>
                                            <img
                                                src={banner.img}
                                                alt={banner.alt}
                                                className="img-fluid"
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        )}
                        {/* Dynamic Tab Content */}
                        <div className="details-box mt-3">{tabContent[activeTab]}</div>
                    </div>

                    {/* RIGHT SIDEBAR */}
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="sideNav-box">
                            <h2>Navigation</h2>
                            <ul>
                                <li
                                    onClick={() => setActiveTab("about")}
                                    className={activeTab === "about" ? "active" : ""}>
                                    <Link>About Dept</Link>
                                </li>
                                <li
                                    onClick={() => setActiveTab("vision")}
                                    className={activeTab === "vision" ? "active" : ""}>
                                    <Link>Dept. Vision & Mission</Link>
                                </li>
                                <li
                                    onClick={() => setActiveTab("peos")}
                                    className={activeTab === "peos" ? "active" : ""}>
                                    <Link>PEO's, PSO's and PO's</Link>
                                </li>
                                <li
                                    onClick={() => setActiveTab("faculty")}
                                    className={activeTab === "faculty" ? "active" : ""} >
                                    <Link>Faculty & Staff</Link>
                                </li>


                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Departments;
